import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useTaskPrioritySelect } from './useTaskPrioritySelect';

interface TaskPrioritySelectProps {
  onOpenPicker: () => void;
}

/** It renders the trigger button directly, which the form's focus helpers rely on. */
const TaskPrioritySelect = ({ onOpenPicker }: Readonly<TaskPrioritySelectProps>) => {
  const { t } = useTranslation();
  const select = useTaskPrioritySelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('task:priority')}
      placeholder={t('task:selectPriority')}
      searchPlaceholder={t('common:search')}
      onSearchIconClick={onOpenPicker}
      data-field="priority"
      data-testid="priority-button"
    />
  );
};

export default TaskPrioritySelect;
